import { IPageAddCallback, api } from "./index";
import { message } from "antd";
import { lang } from "../context";
import events from "../context/events";
import { isBjme } from "@/utils";
import { ActionFnEnum, ActionType, FileType } from "../types";

const shortcut: IPageAddCallback = (props, isAllow) => {
  const { data, setData } = props;

  const title = data.isShortcuted ? "取消置顶" : "置顶";
  let type = data.page_type ? FileType.Page : FileType.Folder;
  const callback = () => {
    message.success(lang("common.success"));
    events.emit("shortcut.change");
    const newData = {
      ...data,
      isShortcuted: !data.isShortcuted
    };
    const id = type === FileType.Page ? data.page_id : data.id;
    setData({
      type: ActionFnEnum.UPDATE,
      newItem: newData,
      id,
      actionType: type === FileType.Page ? ActionType.Page : ActionType.Folder
    } as any);
    events.emit("list.check");
  };
  return [
    {
      children: title,
      splitCode: 1,
      icon: data.isShortcuted ? "pc_yundoc_retop" : "pc_yundoc_top",
      callbackOrModal: () => {
        if (data.isShortcuted) {
          api.page.shortcuts.remove(data.id, type).then((res) => {
            if (!res) {
              message.error(lang("common.fail"));
              return;
            }
            callback();
          });
        } else {
          api.page.shortcuts.add(data.id, type).then((res) => {
            if (!res) {
              message.error(lang("common.fail"));
              return;
            }
            callback();
          });
        }
      },
      isAllow,
      type: "shortcut"
    }
  ];
};

export default shortcut;
